import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TConversation, TMessage } from 'types/inbox';
import InboxMessage from '../InboxMessage';
import { openTextVisitUnSubmittedDrawer, openTextVisitSubmittedDrawer, openVideoVisitSubmittedDrawer, openNonAppointmentSubmittedDrawer } from 'utils/globalLayerControl';
import s from './s.module.less';
import { PATH } from 'constants/path';
import useTimezone from 'hooks/useTimezone';
import { SUPPORT_TIME_ZONE } from 'constants/common';
import ChargeModal from 'pages/dashboard/ProspectsDetailPage/components/prosepectInfo/components/ChargeModal';
import { getUserId } from 'utils/localstore';
import { IBillingPolicy } from 'types/paymentSetup';
import { IConnectAccountInfoResponse } from 'hooks/useGetConnectAccountInfo';
import useCurrentUser from 'hooks/useCurrentUser';
import { canShowGroupPracticeView } from 'utils/common';

type Props = {
    inboxMessageList?: TMessage[];
    inboxConversation?: TConversation;
    onReviewReplySuccess?: () => void;
    blockOpenTextVisitModal?: boolean;
    clientId?: number;
    billingPolicy?: IBillingPolicy[];
    connectAccountInfo?: IConnectAccountInfoResponse;
    skipReadAction?: boolean;
};

const InboxMessageList = (props: Props) => {
    const {
        inboxMessageList,
        inboxConversation,
        onReviewReplySuccess,
        blockOpenTextVisitModal,
        clientId,
        billingPolicy,
        connectAccountInfo,
        skipReadAction,
    } = props;
    const [, myTimezone, isDifferentTimezoneWithBrowser] = useTimezone(true);
    const navigate = useNavigate();
    const [showChargeModal, setShowChargeModal] = useState(false);
    const [currentUserData] = useCurrentUser();
    const showGroupPracticeView = canShowGroupPracticeView(currentUserData);

    let targetTimezone:
        | undefined
        | {
              dictKey: string;
              offset: string;
          };
    //not same as browser timezone
    if (myTimezone?.value) {
        targetTimezone = SUPPORT_TIME_ZONE.find(
            (item) => item.dictKey.toLowerCase() === (myTimezone?.value as string).toLowerCase(),
        );
    }

    return (
        <div className={s.wrap}>
            {inboxMessageList?.map((item, index) => {
                return (
                    <InboxMessage
                        inboxConversation={inboxConversation}
                        inboxMessage={item}
                        type="PROVIDER"
                        onReviewReplySuccess={onReviewReplySuccess}
                        onViewTextVisit={(uuid) => {
                            const textVisitUuid = item.textVisit?.textVisitUuid || uuid || '';
                            openTextVisitSubmittedDrawer(textVisitUuid);
                        }}
                        showGroupPracticeView={showGroupPracticeView}
                        currentUserId={currentUserData?.user?.id}
                        onAcceptTextVisit={(textVisitId, openChargeAfterSubmit) => {
                            const uuid = item.textVisit?.textVisitUuid || '';
                            console.log({ openChargeAfterSubmit });
                            openTextVisitUnSubmittedDrawer(
                                uuid,
                                () => {
                                    if (openChargeAfterSubmit) {
                                        //todo
                                        setShowChargeModal(true);
                                    } else {
                                        navigate(`${PATH.DASHBOARD}/${PATH.TEXT_VISIT}?tab=my`);
                                    }
                                },
                                true,
                            );
                        }}
                        key={item.sortKey || `idx-${index}`}
                        onViewVideoVisit={(id) => {
                            const appointmentId = item.appointment?.id || id || 0;
                            openVideoVisitSubmittedDrawer(appointmentId);
                        }}
                        onViewStandaloneNote={(noteId) => {
                            openNonAppointmentSubmittedDrawer(noteId);
                        }}
                        blockOpenTextVisitModal={blockOpenTextVisitModal}
                        timezone={isDifferentTimezoneWithBrowser ? targetTimezone?.dictKey : undefined}
                    />
                );
            })}
            <ChargeModal
                connectAccountInfo={connectAccountInfo}
                providerId={getUserId()}
                clientId={clientId}
                billingPolicy={billingPolicy?.sort((a, b) => a.id - b.id)}
                open={showChargeModal}
                onCancel={() => setShowChargeModal(false)}
                type="prescription-refill"
                onSuccess={(amount) => {
                    setShowChargeModal(false);
                }}
            />
        </div>
    );
};

export default InboxMessageList;
